module.exports = __webpack_public_path__ + "static/Kastelov - Axiforma Bold-ffc358f84c0317178f3310075753bded.otf";